<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">Configuracion de Mercado</h1>
        <b-row>
          <b-col cols="12">
            <b-card>
              <b-spinner v-if="loading"></b-spinner>
              <b-form v-if="ready">
                <b-form-group label="Nombre" label-for="name">
                  <b-form-input
                    id="name"
                    :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
                    v-model="$v.form.name.$model"
                  />
                </b-form-group>
                <h3>Materia prima</h3>
                <h5>Restricciones comerciales</h5>
                <b-form-group label="Variedades aceptadas" label-for="comercialRestrictions">
                  <v-select
                    label="name"
                    :options="varieties"
                    :reduce="(item) => item.id"
                    multiple
                    v-model="form.accepted_varieties"
                  >
                    <template #option="variety">
                      <b>
                        {{ variety.name }}
                      </b>
                      <br />
                      <cite class="text-small">{{ variety.product.name }}</cite>
                    </template>
                  </v-select>
                </b-form-group>
                <h5>Restricciones de calidad</h5>
                <b-form-group label="Calidades aceptadas" label-for="comercialRestrictions">
                  <v-select
                    label="name"
                    :options="classifications"
                    multiple
                    :reduce="(item) => item.name"
                    v-model="form.accepted_classifications"
                  >
                    <template #option="classification">
                      <i :class="'fa fa-circle pr-1 text-' + getBootstrapColorName(classification.color)"></i>
                      {{ classification.name }}
                      <!-- <cite class="text-small">{{ classification.product.name }}</cite> -->
                    </template>
                    <template #selected-option="classification">
                      <div
                        style="display: flex; align-items: baseline"
                        :class="'text-' + getBootstrapColorName(classification.color)"
                      >
                        <strong>{{ classification.name }}</strong>
                      </div>
                    </template>
                  </v-select>
                </b-form-group>
                <h5>Restricciones de inocuidad y SAG (Todas se deben cumplir)</h5>
                <b-form-group label="Certificados y permisos exigidos" label-for="varieties">
                  <v-select :options="certificates" multiple v-model="form.accepted_certs"></v-select>
                </b-form-group>
                <h5>Restricciones de inocuidad y SAG(Alguna se debe cumplir)</h5>
                <b-form-group label="Certificados y permisos exigidos" label-for="varieties">
                  <v-select :options="certificates" multiple v-model="form.accepted_certs_or"></v-select>
                </b-form-group>
                <h3>PT</h3>
                <h5>Codigos de formato permitidos</h5>
                <b-form-group label="Formatos permitidos" label-for="cointaineers">
                  <v-select
                    label="text"
                    :options="containers"
                    multiple
                    v-model="form.accepted_containers"
                    :reduce="(item) => item.value.id"
                  ></v-select>
                </b-form-group>
                <b-button @click.prevent="saveMarket" class="float-right" variant="primary">Guardar</b-button>
              </b-form>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { getBootstrapColorName } from "../../utils";
export default {
  data() {
    return {
      ready: false,
      loading: false,
      form: {
        name: "",
        accepted_certs: [],
        accepted_certs_or: [],
        accepted_varieties: [],
        accepted_classifications: [],
        accepted_containers: []
      },
      varieties: [],
      classifications: [],
      certificates: [],
      containers: []
    };
  },
  props: {
    id: {
      type: Number
    }
  },
  validations: {
    form: {
      name: {
        required
      }
    }
  },
  methods: {
    getBootstrapColorName,
    resetForm() {
      this.form = {
        id: "",
        name: ""
      };
    },
    onSubmit() {
      this.$v.touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.saveMarket();
      }
    },
    async saveMarket() {
      this.loading = true;
      try {
        let response;
        let body = this.form;
        delete body["s_accepted_varieties"];
        delete body["s_accepted_classifications"];
        delete body["s_accepted_containers"];
        if (this.form.id === 0) {
          response = await this.$axios.post(`/api/comex/market/`, body);
        } else {
          response = await this.$axios.put(`/api/comex/market/${this.form.id}/`, body);
        }
        this.$swal({
          title: "Éxito",
          text: "Mercado guardado correctamente",
          type: "success",
          confirmButtonText: "Aceptar"
        });
        this.resetForm();
        this.$router.push({ name: "comercial-mercados" });
      } catch (error) {
        this.$bvToast.toast(`Error al crear el usuario`, {
          title: "Error",
          variant: "danger"
        });
      }
      this.loading = false;
    },
    async getMarket() {
      this.ready = false;
      this.loading = true;
      if (this.form.id !== 0) {
        try {
          const response = await this.$axios.get(`/api/comex/market/${this.form.id}/`);
          this.form = response.data;
          this.loading = false;
        } catch (error) {
          console.log(error);
          this.loading = false;
        }
      } else {
        this.loading = false;
      }
      this.$nextTick(() => {
        this.ready = true;
      });
    },
    // get varieties
    async getVarieties() {
      this.loading = true;
      try {
        const response = await this.$axios.get(`/api/v1/variety/?no_page`);
        this.varieties = response.data;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    // Get classifications
    async getClassifications() {
      this.loading = true;
      try {
        const response = await this.$axios.get(`/api/qc/inspection/options/`);
        this.classifications = response.data;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    // Get containers
    async getContainers() {
      this.loading = true;
      try {
        const response = await this.$axios.get(`/api/v1/container/?no_page`);
        this.containers = response.data;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    // Get certificate
    async getCertificates() {
      this.loading = true;
      try {
        const response = await this.$axios.get(`/api/qc/certificate_config/all_certificates/`);
        this.certificates = response.data.data;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    }
  },
  mounted() {
    this.form.id = this.$route.params.id;
    this.getMarket();
    this.getVarieties();
    this.getClassifications();
    this.getContainers();
    this.getCertificates();
  }
};
</script>

<style></style>
